import { tUnderConstruction } from "./SL00000Sprint00"
import { ptt_5_slidedeck } from './SL36000Sprint05'
import { ptt_6_slidedeck } from './SL36000Sprint06'
import { ptt_7_slidedeck } from './SL36000Sprint07'

const underConstructionDeck = [ tUnderConstruction ]
const underConstructionSprint = [ underConstructionDeck, underConstructionDeck, underConstructionDeck, underConstructionDeck, underConstructionDeck, underConstructionDeck ]

export const ptt_slidedeck = [ underConstructionSprint, underConstructionSprint, underConstructionSprint, underConstructionSprint, ptt_5_slidedeck, ptt_6_slidedeck, ptt_7_slidedeck ]